import React from 'react'
import { Container } from 'reactstrap'

const Footer = () => (
	<div className="footer">
		<Container fluid>
			<span>Blog by</span>
			<span>&nbsp;</span>
			<span>
				<a href="https://twitter.com/ryaneshea"
				target="_blank" rel="noopener noreferrer">
					Ryan Shea
				</a>
			</span>
		</Container>
	</div>
)

export default Footer